"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Quote_1 = __importDefault(require("./Quote"));
var QuoteLineItem_1 = __importDefault(require("./QuoteLineItem"));
var QuotePlanCard_1 = __importDefault(require("./QuotePlanCard"));
var QuotePlanCardFeatureList_1 = __importDefault(require("./QuotePlanCardFeatureList"));
var Standard_1 = __importDefault(require("./Standard"));
var Agreement_1 = __importDefault(require("./Agreement"));
var configurations = {
    standard: Standard_1.default,
    quote: Quote_1.default,
    quoteLineItem: QuoteLineItem_1.default,
    quotePlanCard: QuotePlanCard_1.default,
    quotePlanCardFeatureList: QuotePlanCardFeatureList_1.default,
    agreement: Agreement_1.default,
};
exports.default = configurations;
